<script setup lang="ts">
import { AppInput } from '@shared/ui/inputs'

import {
  useInputCallbackTopic,
} from '../../../../model/additional-info/support/info-callback-request/input-callback-topic.hook'

defineOptions({
  name: 'InputCallbackTopic',
})

const {
  inputType,
  model,
  placeholder,
} = useInputCallbackTopic()
</script>

<template>
  <AppInput
    v-model="model"
    :type="inputType"
    :placeholder="placeholder"
  />
</template>
